

export const MSG_DELETE_CONFIRM = "Are you sure you want to delete '{0}' ?";
export const MSG_DELETE_CONTENT_CONFIRM = "This file will be deleted and cannot be restored.<br>Are you sure you want to delete '{0}' ?";
